"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AddCircleBoldIcon", {
  enumerable: true,
  get: function () {
    return _AddCircleBoldIcon.AddCircleBoldIcon;
  }
});
Object.defineProperty(exports, "AddCircleIcon", {
  enumerable: true,
  get: function () {
    return _AddCircleIcon.AddCircleIcon;
  }
});
Object.defineProperty(exports, "AlarmBellBoldIcon", {
  enumerable: true,
  get: function () {
    return _AlarmBellBoldIcon.AlarmBellBoldIcon;
  }
});
Object.defineProperty(exports, "AlarmBellIcon", {
  enumerable: true,
  get: function () {
    return _AlarmBellIcon.AlarmBellIcon;
  }
});
Object.defineProperty(exports, "ArrowDownIcon", {
  enumerable: true,
  get: function () {
    return _ArrowDownIcon.ArrowDownIcon;
  }
});
Object.defineProperty(exports, "ArrowFirstIcon", {
  enumerable: true,
  get: function () {
    return _ArrowFirstIcon.ArrowFirstIcon;
  }
});
Object.defineProperty(exports, "ArrowLastIcon", {
  enumerable: true,
  get: function () {
    return _ArrowLastIcon.ArrowLastIcon;
  }
});
Object.defineProperty(exports, "ArrowRightCircleIcon", {
  enumerable: true,
  get: function () {
    return _ArrowRightCircleIcon.ArrowRightCircleIcon;
  }
});
Object.defineProperty(exports, "AtmCircleIcon", {
  enumerable: true,
  get: function () {
    return _AtmCircleIcon.AtmCircleIcon;
  }
});
Object.defineProperty(exports, "AttachmentBoldIcon", {
  enumerable: true,
  get: function () {
    return _AttachmentBoldIcon.AttachmentBoldIcon;
  }
});
Object.defineProperty(exports, "AttachmentIcon", {
  enumerable: true,
  get: function () {
    return _AttachmentIcon.AttachmentIcon;
  }
});
Object.defineProperty(exports, "BarChartIcon", {
  enumerable: true,
  get: function () {
    return _BarChartIcon.BarChartIcon;
  }
});
Object.defineProperty(exports, "BinBoldIcon", {
  enumerable: true,
  get: function () {
    return _BinBoldIcon.BinBoldIcon;
  }
});
Object.defineProperty(exports, "BinIcon", {
  enumerable: true,
  get: function () {
    return _BinIcon.BinIcon;
  }
});
Object.defineProperty(exports, "CalculatorIcon", {
  enumerable: true,
  get: function () {
    return _CalculatorIcon.CalculatorIcon;
  }
});
Object.defineProperty(exports, "CalendarCashIcon", {
  enumerable: true,
  get: function () {
    return _CalendarCashIcon.CalendarCashIcon;
  }
});
Object.defineProperty(exports, "CalendarIcon", {
  enumerable: true,
  get: function () {
    return _CalendarIcon.CalendarIcon;
  }
});
Object.defineProperty(exports, "CheckBadgeIcon", {
  enumerable: true,
  get: function () {
    return _CheckBadgeIcon.CheckBadgeIcon;
  }
});
Object.defineProperty(exports, "CheckBoldIcon", {
  enumerable: true,
  get: function () {
    return _CheckBoldIcon.CheckBoldIcon;
  }
});
Object.defineProperty(exports, "CheckDataIcon", {
  enumerable: true,
  get: function () {
    return _CheckDataIcon.CheckDataIcon;
  }
});
Object.defineProperty(exports, "CheckEmployeesIcon", {
  enumerable: true,
  get: function () {
    return _CheckEmployeesIcon.CheckEmployeesIcon;
  }
});
Object.defineProperty(exports, "ChevronDownBoldIcon", {
  enumerable: true,
  get: function () {
    return _ChevronDownBoldIcon.ChevronDownBoldIcon;
  }
});
Object.defineProperty(exports, "ChevronDownIcon", {
  enumerable: true,
  get: function () {
    return _ChevronDownIcon.ChevronDownIcon;
  }
});
Object.defineProperty(exports, "ChevronLeftBoldIcon", {
  enumerable: true,
  get: function () {
    return _ChevronLeftBoldIcon.ChevronLeftBoldIcon;
  }
});
Object.defineProperty(exports, "ChevronLeftIcon", {
  enumerable: true,
  get: function () {
    return _ChevronLeftIcon.ChevronLeftIcon;
  }
});
Object.defineProperty(exports, "ChevronRightBoldIcon", {
  enumerable: true,
  get: function () {
    return _ChevronRightBoldIcon.ChevronRightBoldIcon;
  }
});
Object.defineProperty(exports, "ChevronRightIcon", {
  enumerable: true,
  get: function () {
    return _ChevronRightIcon.ChevronRightIcon;
  }
});
Object.defineProperty(exports, "ChevronUpBoldIcon", {
  enumerable: true,
  get: function () {
    return _ChevronUpBoldIcon.ChevronUpBoldIcon;
  }
});
Object.defineProperty(exports, "ChevronUpIcon", {
  enumerable: true,
  get: function () {
    return _ChevronUpIcon.ChevronUpIcon;
  }
});
Object.defineProperty(exports, "CogBoldIcon", {
  enumerable: true,
  get: function () {
    return _CogBoldIcon.CogBoldIcon;
  }
});
Object.defineProperty(exports, "CogIcon", {
  enumerable: true,
  get: function () {
    return _CogIcon.CogIcon;
  }
});
Object.defineProperty(exports, "CoinStackedIcon", {
  enumerable: true,
  get: function () {
    return _CoinStackedIcon.CoinStackedIcon;
  }
});
Object.defineProperty(exports, "CommonFileTextIcon", {
  enumerable: true,
  get: function () {
    return _CommonFileTextIcon.CommonFileTextIcon;
  }
});
Object.defineProperty(exports, "DownloadBoldIcon", {
  enumerable: true,
  get: function () {
    return _DownloadBoldIcon.DownloadBoldIcon;
  }
});
Object.defineProperty(exports, "DownloadIcon", {
  enumerable: true,
  get: function () {
    return _DownloadIcon.DownloadIcon;
  }
});
Object.defineProperty(exports, "EmptyBoxIcon", {
  enumerable: true,
  get: function () {
    return _EmptyBoxIcon.EmptyBoxIcon;
  }
});
Object.defineProperty(exports, "EnvelopeCircleIcon", {
  enumerable: true,
  get: function () {
    return _EnvelopeCircleIcon.EnvelopeCircleIcon;
  }
});
Object.defineProperty(exports, "ErrorBoldIcon", {
  enumerable: true,
  get: function () {
    return _ErrorBoldIcon.ErrorBoldIcon;
  }
});
Object.defineProperty(exports, "ErrorCircleBoldIcon", {
  enumerable: true,
  get: function () {
    return _ErrorCircleBoldIcon.ErrorCircleBoldIcon;
  }
});
Object.defineProperty(exports, "ErrorIcon", {
  enumerable: true,
  get: function () {
    return _ErrorIcon.ErrorIcon;
  }
});
Object.defineProperty(exports, "ExternalLinkIcon", {
  enumerable: true,
  get: function () {
    return _ExternalLinkIcon.ExternalLinkIcon;
  }
});
Object.defineProperty(exports, "FaceIdBoldIcon", {
  enumerable: true,
  get: function () {
    return _FaceIdBoldIcon.FaceIdBoldIcon;
  }
});
Object.defineProperty(exports, "FaceIdIcon", {
  enumerable: true,
  get: function () {
    return _FaceIdIcon.FaceIdIcon;
  }
});
Object.defineProperty(exports, "FileCsvIcon", {
  enumerable: true,
  get: function () {
    return _FileCsvIcon.FileCsvIcon;
  }
});
Object.defineProperty(exports, "FileDocIcon", {
  enumerable: true,
  get: function () {
    return _FileDocIcon.FileDocIcon;
  }
});
Object.defineProperty(exports, "FileMoneyIcon", {
  enumerable: true,
  get: function () {
    return _FileMoneyIcon.FileMoneyIcon;
  }
});
Object.defineProperty(exports, "FilePdfIcon", {
  enumerable: true,
  get: function () {
    return _FilePdfIcon.FilePdfIcon;
  }
});
Object.defineProperty(exports, "FilePptIcon", {
  enumerable: true,
  get: function () {
    return _FilePptIcon.FilePptIcon;
  }
});
Object.defineProperty(exports, "FileSearchBoldIcon", {
  enumerable: true,
  get: function () {
    return _FileSearchBoldIcon.FileSearchBoldIcon;
  }
});
Object.defineProperty(exports, "FileSearchIcon", {
  enumerable: true,
  get: function () {
    return _FileSearchIcon.FileSearchIcon;
  }
});
Object.defineProperty(exports, "FileSubmitCircleIcon", {
  enumerable: true,
  get: function () {
    return _FileSubmitCircleIcon.FileSubmitCircleIcon;
  }
});
Object.defineProperty(exports, "FileSubmitIcon", {
  enumerable: true,
  get: function () {
    return _FileSubmitIcon.FileSubmitIcon;
  }
});
Object.defineProperty(exports, "FileTxtIcon", {
  enumerable: true,
  get: function () {
    return _FileTxtIcon.FileTxtIcon;
  }
});
Object.defineProperty(exports, "FileXlsIcon", {
  enumerable: true,
  get: function () {
    return _FileXlsIcon.FileXlsIcon;
  }
});
Object.defineProperty(exports, "FileZipIcon", {
  enumerable: true,
  get: function () {
    return _FileZipIcon.FileZipIcon;
  }
});
Object.defineProperty(exports, "FloppyDiskBoldIcon", {
  enumerable: true,
  get: function () {
    return _FloppyDiskBoldIcon.FloppyDiskBoldIcon;
  }
});
Object.defineProperty(exports, "FloppyDiskIcon", {
  enumerable: true,
  get: function () {
    return _FloppyDiskIcon.FloppyDiskIcon;
  }
});
Object.defineProperty(exports, "GaugeBoldIcon", {
  enumerable: true,
  get: function () {
    return _GaugeBoldIcon.GaugeBoldIcon;
  }
});
Object.defineProperty(exports, "GaugeCircleBoldIcon", {
  enumerable: true,
  get: function () {
    return _GaugeCircleBold.GaugeCircleBoldIcon;
  }
});
Object.defineProperty(exports, "GaugeIcon", {
  enumerable: true,
  get: function () {
    return _GaugeIcon.GaugeIcon;
  }
});
Object.defineProperty(exports, "HouseBoldIcon", {
  enumerable: true,
  get: function () {
    return _HouseBoldIcon.HouseBoldIcon;
  }
});
Object.defineProperty(exports, "HouseIcon", {
  enumerable: true,
  get: function () {
    return _HouseIcon.HouseIcon;
  }
});
Object.defineProperty(exports, "HyperlinkBoldIcon", {
  enumerable: true,
  get: function () {
    return _HyperlinkBoldIcon.HyperlinkBoldIcon;
  }
});
Object.defineProperty(exports, "HyperlinkIcon", {
  enumerable: true,
  get: function () {
    return _HyperlinkIcon.HyperlinkIcon;
  }
});
Object.defineProperty(exports, "IncreaseCircleIcon", {
  enumerable: true,
  get: function () {
    return _IncreaseCircleIcon.IncreaseCircleIcon;
  }
});
Object.defineProperty(exports, "InfoCircleBoldIcon", {
  enumerable: true,
  get: function () {
    return _InfoCircleBoldIcon.InfoCircleBoldIcon;
  }
});
Object.defineProperty(exports, "InfoCircleIcon", {
  enumerable: true,
  get: function () {
    return _InfoCircleIcon.InfoCircleIcon;
  }
});
Object.defineProperty(exports, "InternationalPhoneIcon", {
  enumerable: true,
  get: function () {
    return _InternationalPhoneIcon.InternationalPhoneIcon;
  }
});
Object.defineProperty(exports, "KeyBoldIcon", {
  enumerable: true,
  get: function () {
    return _KeyBoldIcon.KeyBoldIcon;
  }
});
Object.defineProperty(exports, "KeyIcon", {
  enumerable: true,
  get: function () {
    return _KeyIcon.KeyIcon;
  }
});
Object.defineProperty(exports, "LightBulbBoldIcon", {
  enumerable: true,
  get: function () {
    return _LightBulbBoldIcon.LightBulbBoldIcon;
  }
});
Object.defineProperty(exports, "LightBulbIcon", {
  enumerable: true,
  get: function () {
    return _LightBulbIcon.LightBulbIcon;
  }
});
Object.defineProperty(exports, "LockBoldIcon", {
  enumerable: true,
  get: function () {
    return _LockBoldIcon.LockBoldIcon;
  }
});
Object.defineProperty(exports, "LockIcon", {
  enumerable: true,
  get: function () {
    return _LockIcon.LockIcon;
  }
});
Object.defineProperty(exports, "MagicWandIcon", {
  enumerable: true,
  get: function () {
    return _MagicWandIcon.MagicWandIcon;
  }
});
Object.defineProperty(exports, "MenuBoldIcon", {
  enumerable: true,
  get: function () {
    return _MenuBoldIcon.MenuBoldIcon;
  }
});
Object.defineProperty(exports, "MenuIcon", {
  enumerable: true,
  get: function () {
    return _MenuIcon.MenuIcon;
  }
});
Object.defineProperty(exports, "PackagedFolderIcon", {
  enumerable: true,
  get: function () {
    return _PackagedFolderIcon.PackagedFolderIcon;
  }
});
Object.defineProperty(exports, "PayrollDateIcon", {
  enumerable: true,
  get: function () {
    return _PayrollDateIcon.PayrollDateIcon;
  }
});
Object.defineProperty(exports, "PencilBoldIcon", {
  enumerable: true,
  get: function () {
    return _PencilBoldIcon.PencilBoldIcon;
  }
});
Object.defineProperty(exports, "PencilCircleBoldIcon", {
  enumerable: true,
  get: function () {
    return _PencilCircleBoldIcon.PencilCircleBoldIcon;
  }
});
Object.defineProperty(exports, "PencilIcon", {
  enumerable: true,
  get: function () {
    return _PencilIcon.PencilIcon;
  }
});
Object.defineProperty(exports, "PersonCircleBoldIcon", {
  enumerable: true,
  get: function () {
    return _PersonCircleBoldIcon.PersonCircleBoldIcon;
  }
});
Object.defineProperty(exports, "PersonCircleIcon", {
  enumerable: true,
  get: function () {
    return _PersonCircleIcon.PersonCircleIcon;
  }
});
Object.defineProperty(exports, "PersonMoneyCircleIcon", {
  enumerable: true,
  get: function () {
    return _PersonMoneyCircleIcon.PersonMoneyCircleIcon;
  }
});
Object.defineProperty(exports, "PersonPencilIcon", {
  enumerable: true,
  get: function () {
    return _PersonPencilIcon.PersonPencilIcon;
  }
});
Object.defineProperty(exports, "PersonSearchIcon", {
  enumerable: true,
  get: function () {
    return _PersonSearchIcon.PersonSearchIcon;
  }
});
Object.defineProperty(exports, "PhoneAltIcon", {
  enumerable: true,
  get: function () {
    return _PhoneAltIcon.PhoneAltIcon;
  }
});
Object.defineProperty(exports, "PhoneBoldIcon", {
  enumerable: true,
  get: function () {
    return _PhoneBoldIcon.PhoneBoldIcon;
  }
});
Object.defineProperty(exports, "PhoneIcon", {
  enumerable: true,
  get: function () {
    return _PhoneIcon.PhoneIcon;
  }
});
Object.defineProperty(exports, "PrintBoldIcon", {
  enumerable: true,
  get: function () {
    return _PrintBoldIcon.PrintBoldIcon;
  }
});
Object.defineProperty(exports, "PrintIcon", {
  enumerable: true,
  get: function () {
    return _PrintIcon.PrintIcon;
  }
});
Object.defineProperty(exports, "QuestionCircleBoldIcon", {
  enumerable: true,
  get: function () {
    return _QuestionCircleBoldIcon.QuestionCircleBoldIcon;
  }
});
Object.defineProperty(exports, "QuestionCircleIcon", {
  enumerable: true,
  get: function () {
    return _QuestionCircleIcon.QuestionCircleIcon;
  }
});
Object.defineProperty(exports, "RatingStarBoldIcon", {
  enumerable: true,
  get: function () {
    return _RatingStarBoldIcon.RatingStarBoldIcon;
  }
});
Object.defineProperty(exports, "RatingStarCheckIcon", {
  enumerable: true,
  get: function () {
    return _RatingStarCheckIcon.RatingStarCheckIcon;
  }
});
Object.defineProperty(exports, "RatingStarIcon", {
  enumerable: true,
  get: function () {
    return _RatingStarIcon.RatingStarIcon;
  }
});
Object.defineProperty(exports, "SavingBankCircleIcon", {
  enumerable: true,
  get: function () {
    return _SavingBankCircleIcon.SavingBankCircleIcon;
  }
});
Object.defineProperty(exports, "SavingPiggyDollarsIcon", {
  enumerable: true,
  get: function () {
    return _SavingPiggyDollarsIcon.SavingPiggyDollarsIcon;
  }
});
Object.defineProperty(exports, "SearchBoldIcon", {
  enumerable: true,
  get: function () {
    return _SearchBoldIcon.SearchBoldIcon;
  }
});
Object.defineProperty(exports, "SearchIcon", {
  enumerable: true,
  get: function () {
    return _SearchIcon.SearchIcon;
  }
});
Object.defineProperty(exports, "ShieldBoldIcon", {
  enumerable: true,
  get: function () {
    return _ShieldBoldIcon.ShieldBoldIcon;
  }
});
Object.defineProperty(exports, "ShieldIcon", {
  enumerable: true,
  get: function () {
    return _ShieldIcon.ShieldIcon;
  }
});
Object.defineProperty(exports, "SuccessCircleAltIcon", {
  enumerable: true,
  get: function () {
    return _SuccessCircleAltIcon.SuccessCircleAltIcon;
  }
});
Object.defineProperty(exports, "SuccessCircleBoldIcon", {
  enumerable: true,
  get: function () {
    return _SuccessCircleBoldIcon.SuccessCircleBoldIcon;
  }
});
Object.defineProperty(exports, "SuccessCircleIcon", {
  enumerable: true,
  get: function () {
    return _SuccessCircleIcon.SuccessCircleIcon;
  }
});
Object.defineProperty(exports, "TaskListStarIcon", {
  enumerable: true,
  get: function () {
    return _TaskListStarIcon.TaskListStarIcon;
  }
});
Object.defineProperty(exports, "TimeClockCircleBoldIcon", {
  enumerable: true,
  get: function () {
    return _TimeClockCircleBoldIcon.TimeClockCircleBoldIcon;
  }
});
Object.defineProperty(exports, "TimeClockCircleIcon", {
  enumerable: true,
  get: function () {
    return _TimeClockCircleIcon.TimeClockCircleIcon;
  }
});
Object.defineProperty(exports, "TouchIdBoldIcon", {
  enumerable: true,
  get: function () {
    return _TouchIdBoldIcon.TouchIdBoldIcon;
  }
});
Object.defineProperty(exports, "TouchIdIcon", {
  enumerable: true,
  get: function () {
    return _TouchIdIcon.TouchIdIcon;
  }
});
Object.defineProperty(exports, "UnlockBoldIcon", {
  enumerable: true,
  get: function () {
    return _UnlockBoldIcon.UnlockBoldIcon;
  }
});
Object.defineProperty(exports, "UnlockIcon", {
  enumerable: true,
  get: function () {
    return _UnlockIcon.UnlockIcon;
  }
});
Object.defineProperty(exports, "UploadBoldIcon", {
  enumerable: true,
  get: function () {
    return _UploadBoldIcon.UploadBoldIcon;
  }
});
Object.defineProperty(exports, "UploadCircleIcon", {
  enumerable: true,
  get: function () {
    return _UploadCircleIcon.UploadCircleIcon;
  }
});
Object.defineProperty(exports, "UploadIcon", {
  enumerable: true,
  get: function () {
    return _UploadIcon.UploadIcon;
  }
});
Object.defineProperty(exports, "ViewBoldIcon", {
  enumerable: true,
  get: function () {
    return _ViewBoldIcon.ViewBoldIcon;
  }
});
Object.defineProperty(exports, "ViewIcon", {
  enumerable: true,
  get: function () {
    return _ViewIcon.ViewIcon;
  }
});
Object.defineProperty(exports, "ViewOffIcon", {
  enumerable: true,
  get: function () {
    return _ViewOffIcon.ViewOffIcon;
  }
});
Object.defineProperty(exports, "WarningBoldIcon", {
  enumerable: true,
  get: function () {
    return _WarningBoldIcon.WarningBoldIcon;
  }
});
Object.defineProperty(exports, "WarningCircleBoldIcon", {
  enumerable: true,
  get: function () {
    return _WarningCircleBoldIcon.WarningCircleBoldIcon;
  }
});
Object.defineProperty(exports, "WarningIcon", {
  enumerable: true,
  get: function () {
    return _WarningIcon.WarningIcon;
  }
});
Object.defineProperty(exports, "XBoldIcon", {
  enumerable: true,
  get: function () {
    return _XBoldIcon.XBoldIcon;
  }
});
Object.defineProperty(exports, "XCircleIcon", {
  enumerable: true,
  get: function () {
    return _XCircleIcon.XCircleIcon;
  }
});
Object.defineProperty(exports, "XIcon", {
  enumerable: true,
  get: function () {
    return _XIcon.XIcon;
  }
});
var _AddCircleBoldIcon = require("./react/icons/AddCircleBoldIcon");
var _AddCircleIcon = require("./react/icons/AddCircleIcon");
var _AlarmBellBoldIcon = require("./react/icons/AlarmBellBoldIcon");
var _AlarmBellIcon = require("./react/icons/AlarmBellIcon");
var _ArrowDownIcon = require("./react/icons/ArrowDownIcon");
var _ArrowFirstIcon = require("./react/icons/ArrowFirstIcon");
var _ArrowLastIcon = require("./react/icons/ArrowLastIcon");
var _ArrowRightCircleIcon = require("./react/icons/ArrowRightCircleIcon");
var _AtmCircleIcon = require("./react/icons/AtmCircleIcon");
var _AttachmentBoldIcon = require("./react/icons/AttachmentBoldIcon");
var _AttachmentIcon = require("./react/icons/AttachmentIcon");
var _BarChartIcon = require("./react/icons/BarChartIcon");
var _BinBoldIcon = require("./react/icons/BinBoldIcon");
var _BinIcon = require("./react/icons/BinIcon");
var _CalculatorIcon = require("./react/icons/CalculatorIcon");
var _CalendarIcon = require("./react/icons/CalendarIcon");
var _CalendarCashIcon = require("./react/icons/CalendarCashIcon");
var _CheckBoldIcon = require("./react/icons/CheckBoldIcon");
var _CheckBadgeIcon = require("./react/icons/CheckBadgeIcon");
var _CheckDataIcon = require("./react/icons/CheckDataIcon");
var _CheckEmployeesIcon = require("./react/icons/CheckEmployeesIcon");
var _ChevronDownBoldIcon = require("./react/icons/ChevronDownBoldIcon");
var _ChevronDownIcon = require("./react/icons/ChevronDownIcon");
var _ChevronLeftBoldIcon = require("./react/icons/ChevronLeftBoldIcon");
var _ChevronLeftIcon = require("./react/icons/ChevronLeftIcon");
var _ChevronRightBoldIcon = require("./react/icons/ChevronRightBoldIcon");
var _ChevronRightIcon = require("./react/icons/ChevronRightIcon");
var _ChevronUpBoldIcon = require("./react/icons/ChevronUpBoldIcon");
var _ChevronUpIcon = require("./react/icons/ChevronUpIcon");
var _CogBoldIcon = require("./react/icons/CogBoldIcon");
var _CogIcon = require("./react/icons/CogIcon");
var _CoinStackedIcon = require("./react/icons/CoinStackedIcon");
var _CommonFileTextIcon = require("./react/icons/CommonFileTextIcon");
var _DownloadBoldIcon = require("./react/icons/DownloadBoldIcon");
var _DownloadIcon = require("./react/icons/DownloadIcon");
var _EmptyBoxIcon = require("./react/icons/EmptyBoxIcon");
var _EnvelopeCircleIcon = require("./react/icons/EnvelopeCircleIcon");
var _ErrorBoldIcon = require("./react/icons/ErrorBoldIcon");
var _ErrorCircleBoldIcon = require("./react/icons/ErrorCircleBoldIcon");
var _ErrorIcon = require("./react/icons/ErrorIcon");
var _ExternalLinkIcon = require("./react/icons/ExternalLinkIcon");
var _FaceIdBoldIcon = require("./react/icons/FaceIdBoldIcon");
var _FaceIdIcon = require("./react/icons/FaceIdIcon");
var _FileCsvIcon = require("./react/icons/FileCsvIcon");
var _FileDocIcon = require("./react/icons/FileDocIcon");
var _FileMoneyIcon = require("./react/icons/FileMoneyIcon");
var _FilePdfIcon = require("./react/icons/FilePdfIcon");
var _FilePptIcon = require("./react/icons/FilePptIcon");
var _FileSearchBoldIcon = require("./react/icons/FileSearchBoldIcon");
var _FileSearchIcon = require("./react/icons/FileSearchIcon");
var _FileSubmitCircleIcon = require("./react/icons/FileSubmitCircleIcon");
var _FileSubmitIcon = require("./react/icons/FileSubmitIcon");
var _FileTxtIcon = require("./react/icons/FileTxtIcon");
var _FileXlsIcon = require("./react/icons/FileXlsIcon");
var _FileZipIcon = require("./react/icons/FileZipIcon");
var _FloppyDiskBoldIcon = require("./react/icons/FloppyDiskBoldIcon");
var _FloppyDiskIcon = require("./react/icons/FloppyDiskIcon");
var _GaugeBoldIcon = require("./react/icons/GaugeBoldIcon");
var _GaugeCircleBold = require("./react/icons/GaugeCircleBold");
var _GaugeIcon = require("./react/icons/GaugeIcon");
var _HouseBoldIcon = require("./react/icons/HouseBoldIcon");
var _HouseIcon = require("./react/icons/HouseIcon");
var _HyperlinkBoldIcon = require("./react/icons/HyperlinkBoldIcon");
var _HyperlinkIcon = require("./react/icons/HyperlinkIcon");
var _IncreaseCircleIcon = require("./react/icons/IncreaseCircleIcon");
var _InfoCircleBoldIcon = require("./react/icons/InfoCircleBoldIcon");
var _InfoCircleIcon = require("./react/icons/InfoCircleIcon");
var _InternationalPhoneIcon = require("./react/icons/InternationalPhoneIcon");
var _KeyBoldIcon = require("./react/icons/KeyBoldIcon");
var _KeyIcon = require("./react/icons/KeyIcon");
var _LightBulbBoldIcon = require("./react/icons/LightBulbBoldIcon");
var _LightBulbIcon = require("./react/icons/LightBulbIcon");
var _LockBoldIcon = require("./react/icons/LockBoldIcon");
var _LockIcon = require("./react/icons/LockIcon");
var _MagicWandIcon = require("./react/icons/MagicWandIcon");
var _MenuBoldIcon = require("./react/icons/MenuBoldIcon");
var _MenuIcon = require("./react/icons/MenuIcon");
var _PayrollDateIcon = require("./react/icons/PayrollDateIcon");
var _PackagedFolderIcon = require("./react/icons/PackagedFolderIcon");
var _PencilBoldIcon = require("./react/icons/PencilBoldIcon");
var _PencilCircleBoldIcon = require("./react/icons/PencilCircleBoldIcon");
var _PencilIcon = require("./react/icons/PencilIcon");
var _PersonCircleBoldIcon = require("./react/icons/PersonCircleBoldIcon");
var _PersonCircleIcon = require("./react/icons/PersonCircleIcon");
var _PersonMoneyCircleIcon = require("./react/icons/PersonMoneyCircleIcon");
var _PersonPencilIcon = require("./react/icons/PersonPencilIcon");
var _PersonSearchIcon = require("./react/icons/PersonSearchIcon");
var _PhoneAltIcon = require("./react/icons/PhoneAltIcon");
var _PhoneBoldIcon = require("./react/icons/PhoneBoldIcon");
var _PhoneIcon = require("./react/icons/PhoneIcon");
var _PrintBoldIcon = require("./react/icons/PrintBoldIcon");
var _PrintIcon = require("./react/icons/PrintIcon");
var _QuestionCircleBoldIcon = require("./react/icons/QuestionCircleBoldIcon");
var _QuestionCircleIcon = require("./react/icons/QuestionCircleIcon");
var _RatingStarBoldIcon = require("./react/icons/RatingStarBoldIcon");
var _RatingStarCheckIcon = require("./react/icons/RatingStarCheckIcon");
var _RatingStarIcon = require("./react/icons/RatingStarIcon");
var _SavingBankCircleIcon = require("./react/icons/SavingBankCircleIcon");
var _SavingPiggyDollarsIcon = require("./react/icons/SavingPiggyDollarsIcon");
var _SearchBoldIcon = require("./react/icons/SearchBoldIcon");
var _SearchIcon = require("./react/icons/SearchIcon");
var _ShieldBoldIcon = require("./react/icons/ShieldBoldIcon");
var _ShieldIcon = require("./react/icons/ShieldIcon");
var _SuccessCircleAltIcon = require("./react/icons/SuccessCircleAltIcon");
var _SuccessCircleBoldIcon = require("./react/icons/SuccessCircleBoldIcon");
var _SuccessCircleIcon = require("./react/icons/SuccessCircleIcon");
var _TaskListStarIcon = require("./react/icons/TaskListStarIcon");
var _TimeClockCircleIcon = require("./react/icons/TimeClockCircleIcon");
var _TimeClockCircleBoldIcon = require("./react/icons/TimeClockCircleBoldIcon");
var _TouchIdBoldIcon = require("./react/icons/TouchIdBoldIcon");
var _TouchIdIcon = require("./react/icons/TouchIdIcon");
var _UnlockBoldIcon = require("./react/icons/UnlockBoldIcon");
var _UnlockIcon = require("./react/icons/UnlockIcon");
var _UploadBoldIcon = require("./react/icons/UploadBoldIcon");
var _UploadCircleIcon = require("./react/icons/UploadCircleIcon");
var _UploadIcon = require("./react/icons/UploadIcon");
var _ViewBoldIcon = require("./react/icons/ViewBoldIcon");
var _ViewIcon = require("./react/icons/ViewIcon");
var _ViewOffIcon = require("./react/icons/ViewOffIcon");
var _WarningBoldIcon = require("./react/icons/WarningBoldIcon");
var _WarningCircleBoldIcon = require("./react/icons/WarningCircleBoldIcon");
var _WarningIcon = require("./react/icons/WarningIcon");
var _XCircleIcon = require("./react/icons/XCircleIcon");
var _XIcon = require("./react/icons/XIcon");
var _XBoldIcon = require("./react/icons/XBoldIcon");